import { FC } from "react";
import { Grid } from "@mui/material";
import BasicKPIComponent from "../../../../Dashboard/BasicKPIComponent";
import { EventActivityKpis as EventActivityKpisData } from "../../../../../services/reports.service";

interface EventActivityKpisProps {
	kpis: EventActivityKpisData;
}

const pct = (numerator: number, denominator: number): string => {
	if (denominator === 0) return "0%";
	return `${((numerator / denominator) * 100).toFixed(1)}%`;
};

const EventActivityKpis: FC<EventActivityKpisProps> = ({ kpis }) => {
	const { expected, submitted, missed, pending } = kpis;
	return (
		<Grid container spacing={2}>
			<BasicKPIComponent
				title="Expected submissions"
				content={expected}
				footer={{ hidden: true }}
			/>
			<BasicKPIComponent
				title="Submitted"
				content={`${submitted} (${pct(submitted, expected)})`}
				footer={{ hidden: true }}
			/>
			<BasicKPIComponent
				title="Missed"
				content={`${missed} (${pct(missed, expected)})`}
				footer={{ hidden: true }}
			/>
			<BasicKPIComponent
				title="Pending"
				content={`${pending} (${pct(pending, expected)})`}
				footer={{ hidden: true }}
			/>
		</Grid>
	);
};

export default EventActivityKpis;
